import { http } from './http';
import { api } from './endpoints';
import { NewsSearchResult } from '@/vue_components/news-overview/News';

export const newsService = {
    getNews(keyword:string = "", start:number = -1, take:number = 0) {
        return http.get(api.search.news.getNews(keyword, start, take)).then(r => new NewsSearchResult(r.data));
    },
    getCategories(){
        return http.get(api.search.news.getCategories()).then(r => r.data);
    },
    getIframe(alias:string){
        return http.get(api.search.news.getIframe(alias)).then(r => r.data);
    }
};
export type NewsService = typeof newsService;
